import React from 'react';
import { portfolioItems } from '../data/mock';

const Portfolio = () => {
  return (
    <section className="portfolio-modern" id="portfolio">
      <div className="container-modern">
        <div className="section-header-modern centered">
          <span className="section-label-modern">OUR WORK</span>
          <h2 className="section-title-modern">Portfolio Showcase</h2>
          <p className="section-description-modern">
            Precision manufacturing delivered across industries
          </p>
        </div>
        
        <div className="portfolio-masonry">
          {portfolioItems.map((item) => (
            <div 
              key={item.id} 
              className={`portfolio-item ${item.size}`}
            >
              <div className="portfolio-image-wrapper">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="portfolio-img"
                />
                <div className="portfolio-overlay">
                  <div className="portfolio-content">
                    <span className="portfolio-category">{item.category}</span>
                    <h3 className="portfolio-title">{item.title}</h3>
                    <p className="portfolio-description">{item.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
